import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class HttpService {

    // eslint-disable-next-line @typescript-eslint/naming-convention
    headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    // headers.append('Access-Control-Allow-Origin', 'http://localhost:3000');
    // headers.append('Access-Control-Allow-Credentials', 'true');

    options = { headers: this.headers, withCredintials: true };

    constructor(private http: HttpClient) {
        // //console.log('---->>>>',this.headers);
    }


    post(serviceName: string, data: any) {
        const url = environment.apiBaseUrl + serviceName;

        return this.http.post(url, data, this.options);
    }

    put(serviceName: string, data: any) {
        const url = environment.apiBaseUrl + serviceName;
        return this.http.put(url, data, this.options);
    }

    get(serviceName: string) {
        const url = environment.apiBaseUrl + serviceName;
        return this.http.get(url, this.options);
    }


}
